import React, { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import {
  Root,
  Status,
  Input,
  Submit,
  InputContainer,
  InputLabel,
} from "./SubscribeForm.style";

const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const SubscribeForm = ({ placeholder = "Subscribe", submitText = "Submit", isShop = false }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [emailAddress, setEmailAddress] = useState("");
  const [formStatus, setFormStatus] = useState("");

  const handleSubmit = async e => {
    e.preventDefault();
    if (emailAddress == null || emailAddress === '') return;
    if (!emailPattern.test(emailAddress)) {
      setFormStatus("Invalid Email.");
      return;
    }
    if (!executeRecaptcha) {
      setFormStatus("Invalid reCAPTCHA. Please try again.");
      return;
    }
    const captchaToken = await executeRecaptcha("subscribe");

    try {
      setFormStatus("Submitting...");
      const response = await fetch(
        `https://api.olesmoky.com/subscribe-jamesownby`,
        {
          method: "POST",
          headers: {
            'Accept': 'application/json', 
            'Content-Type': 'application/json' 
          },
          body: JSON.stringify({ 
            emailAddress, 
            captchaToken,
            source: "jamesownby-website-subscribe",
            listId: "THDGFS",
          }),
          credentials: 'include',
        },
      );
      console.info({ response });
      setEmailAddress("");
      setFormStatus("Success signing up!");
    } catch (err) {
      const errorJson = err.responseJSON;
      if (
        ["INVALID_CAPTCHA", "INVALID_CAPTCHA_SCORE"].includes(errorJson.type)
      ) {
        setFormStatus("Invalid captcha. Please try again.");
      } else {
        setFormStatus("An error occurred. Please try again.");
      }
    }
  };

  const handleFocus = () => {
    const recaptchaEl = document.getElementsByClassName("grecaptcha-badge");
    recaptchaEl[0].style.visibility = "visible";
  };

  return (
    <Root onSubmit={handleSubmit}>
      <InputLabel htmlFor="subscribe-input">Email*</InputLabel>
      <Input
        type="text"
        name="subscribe"
        id="subscribe-input"
        placeholder={placeholder}
        value={emailAddress}
        onChange={e => setEmailAddress(e.target.value)}
        onFocus={handleFocus}
        autoComplete="email"
        required
        aria-describedby={formStatus ? "status" : undefined}
      />
       <Status id="status" role="status" $isShop={isShop}>{formStatus}</Status>
      <Submit type="submit" $isShop={isShop}>{submitText}</Submit>
  </Root>
  )
}

export default SubscribeForm
